export const publicRoutes = ["", "logout", "document-center"]